/* ══════════════════════════════════════════════════════════════
   Route Definitions for 8-Page Architecture
   ══════════════════════════════════════════════════════════════ */

export interface RouteConfig {
    path: string;
    name: string;
    icon: string;
    label: string;
    showInNav: boolean;
    showInMobileNav: boolean;
}

export const ROUTES: RouteConfig[] = [
    { path: '/', name: 'dashboard', icon: '🏠', label: 'Dashboard', showInNav: true, showInMobileNav: true },
    { path: '/session-radar', name: 'session-radar', icon: '📡', label: 'Session Radar', showInNav: true, showInMobileNav: false },
    { path: '/strategy', name: 'strategy', icon: '📊', label: 'Strategy', showInNav: true, showInMobileNav: true },
    { path: '/intelligence', name: 'intelligence', icon: '📰', label: 'Intelligence', showInNav: true, showInMobileNav: true },
    { path: '/markets', name: 'markets', icon: '📈', label: 'Markets', showInNav: true, showInMobileNav: true },
    { path: '/options', name: 'options', icon: '🧮', label: 'Options', showInNav: false, showInMobileNav: false },
    { path: '/portfolio', name: 'portfolio', icon: '💼', label: 'Portfolio', showInNav: true, showInMobileNav: false },
    { path: '/ipo-earnings', name: 'ipo-earnings', icon: '💼', label: 'IPO & Earnings', showInNav: true, showInMobileNav: false },
    { path: '/backtest', name: 'backtest', icon: '📉', label: 'Backtest', showInNav: true, showInMobileNav: false },
    { path: '/world-monitor', name: 'world-monitor', icon: '🌍', label: 'MONITOR', showInNav: true, showInMobileNav: false },
    { path: '/chat', name: 'chat', icon: '💬', label: 'Chat', showInNav: true, showInMobileNav: true },
    { path: '/settings', name: 'settings', icon: '⚙️', label: 'Settings', showInNav: true, showInMobileNav: true },
];

export const MOBILE_NAV_ROUTES = ROUTES.filter(r => r.showInMobileNav);
export const NAV_ROUTES = ROUTES.filter(r => r.showInNav);

export function getRouteByPath(path: string): RouteConfig | undefined {
    return ROUTES.find(r => r.path === path);
}

export function getRouteByName(name: string): RouteConfig | undefined {
    return ROUTES.find(r => r.name === name);
}
